<template>
    <FormRow :fieldNameArr="['']">
        <Table width="600" border :columns="documentColumnList" :data="plmQuotationDocuments" slot="a">
            <template slot-scope="{ row }" slot="action">
                <Button type="success" shape="circle" icon="md-download" @click="downloadDocument(row)"></Button>
            </template>
        </Table>
        <Button type="primary" @click="downloadDocumentPackage" slot="b">{{ $t('DOWNLOAD_PACKAGE') }}</Button>
    </FormRow>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { DownloadFile, ExceptionHandling } from "@/util/common"

export default {
    name: "PLMDocument",
    created() {
    },
    props: {
        plmQuotationDocuments: {
            type: Array,
            default: () => [],
        },
        quotationUuid: {
            type: String, 
            default: ""
        }
    },
    methods: {
        ...mapGetters(["getUserProfile", "getLanguage", "setContentType"]),
        ...mapActions(["toggleLoading"]),
        downloadDocumentPackage() {
            this.toggleLoading(true)
            this.$quotationHttp
                .get("/document/" + this.quotationUuid  + "/download/zip", { responseType: 'arraybuffer' })
                .then((response) => {
                    const blob = new Blob([response.data], {type: 'application/zip'})
                    DownloadFile(blob, response.headers['content-disposition'].split('\"')[1])
                })
                .catch((error) => {
                    let text = ExceptionHandling(error.response)
                    vueInstance.$Swal.fire({
                        icon: "error",
                        title: Translate("COMMON_MESSAGE_ERROR"),
                        html: text,
                    })
                })
                .finally(() => {
                    this.toggleLoading(false)
                })
        },
        downloadDocument(row) {
            this.toggleLoading(true)
            this.$quotationHttp
                .post("/document/" + this.quotationUuid  + "/download/", JSON.stringify(row), { responseType: 'blob' })
                .then((response) => {
                    const blob = new Blob([response.data])
                    DownloadFile(blob, response.headers['content-disposition'].split('\"')[1])
                    this.toggleLoading(false)
                })
                .catch(() => {})
                .finally(() => {
                    this.toggleLoading(false)
                })
            },
        },
    data() {
        return {
            documentColumnList: [
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('NAME')
                        return h('div', {
                        domProps:{
                            innerHTML:  text
                        }
                        })
                    },
                    key: 'fileName',
                    align: 'center',
                    width: 200,
                },
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('ACTION')
                        return h('div', {
                        domProps:{
                            innerHTML:  text
                        }
                        })
                    },
                    slot: 'action',
                    align: 'center',
                    width: 120,
                },
            ],
        }
    }
}
</script>

<style scoped></style>